module.exports = __webpack_public_path__ + "static/media/Cat_sleep_bed.ad99f552.jpg";